import { LOGOUT } from '../currentUser/currentUser.reducer';

export const reducer = appReducers => (state = undefined, action) => {
  if (action.type === LOGOUT) {
    return appReducers(undefined, action);
  }

  return appReducers(state, action);
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/root/root.reducer.js